// src/data/exercises/L1_03.js

const accountOptions = [
  '商品', '備品', '仕入', '未払金', '買掛金'];

export const L1_03 = {
  title: '簿記　3級（第217-3回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
        
       parts: [
        { type: 'ruby', text: '鳥取', ruby: 'とっとり' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '業務用', ruby: 'ぎょうむよう' },
        { type: 'text', value: 'としてパソコン￥600,000を' },
        { type: 'ruby', text: '購入', ruby: 'こうにゅう' },
        { type: 'text', value: 'し，その' },
        { type: 'ruby', text: '代金', ruby: 'だいきん' },
        { type: 'text', value: 'は，' },
        { type: 'ruby', text: '配送料', ruby: 'はいそうりょう' },
        { type: 'text', value: '・' },
        { type: 'ruby', text: '据付費', ruby: 'すえつけひ' },
        { type: 'text', value: 'などの' },
        { type: 'ruby', text: '諸経費', ruby: 'しょけいひ' },
        { type: 'text', value: '￥30,000とともに' },
        { type: 'ruby', text: '後日', ruby: 'ごじつ' },
        { type: 'ruby', text: '支払う', ruby: 'しはらう' },
        { type: 'text', value: 'こととした。' }
    ]
    
    
    ,


      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '備品', debitAmount: 630000, creditAccount: '未払金', creditAmount: 630000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '業務用としてパソコン￥600,000を購入し \n' },
          { type: 'text', value: '配送料・据付費などの諸経費￥30,000とともに \n' },
          { type: 'text', value: '①業務用としてパソコン￥600,000を購入し→備品の増加（プラス） \n' },
          { type: 'text', value: '備品の金額は、パソコン￥600,000と諸経費￥30,000の合計 \n' },
          { type: 'styled', value: '備品の増加（プラス）は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '後日支払うこととした。 \n' },
          { type: 'text', value: '②後日支払う→未払金の増加（プラス） \n' },
          { type: 'styled', value: '未払金の増加（プラス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`「業務用としてパソコン￥600,000を購入し
配送料・据付費などの諸経費￥30,000とともに
①業務用としてパソコン￥600,000を購入し→備品の増加（プラス）
備品の金額は、パソコン￥600,000と諸経費￥30,000の合計

「後日支払うこととした。
②後日支払う→未払金の増加（プラス） `,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
            parts: [
          { type: 'text', value: '業務用としてパソコン￥600,000を購入し \n' },
          { type: 'text', value: '配送料・据付費などの諸経費￥30,000とともに \n' },
          { type: 'text', value: '①業務用としてパソコン￥600,000を購入し→備品の増加（プラス） \n' },
          { type: 'text', value: '備品の金額は、パソコン￥600,000と諸経費￥30,000の合計 \n' },
          { type: 'styled', value: '備品の増加（プラス）は借方（左・Ｄｒ）に記入します。 \n\n', color: 'red', bold: true },
          { type: 'text', value: '後日支払うこととした。 \n' },
          { type: 'text', value: '②後日支払う→未払金の増加（プラス） \n' },
          { type: 'styled', value: '未払金の増加（プラス）は貸方（右・Ｃｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
        
      },
    },
  ],
};